const handleGlobalInputChange = (e, setFormData) => {
    const { name, type, files, value, checked } = e.target;
    console.log("value", value);

    if (type === "file") {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: files.length > 0 ? files[0] : null,
        }));
    } else if (type === "checkbox") {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: checked,
        }));
    } else {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }
};

export { handleGlobalInputChange };
